(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }

    // Stand-Along Send Communication ViewModel
    function SendCommunicationViewModel() {

        // Self-Identification
        var self = this;

        // Properties
        this.Subject = ko.validatedObservable();
        this.FromAddress = ko.validatedObservable();
        this.ToAddress = ko.validatedObservable();
        this.Html = ko.validatedObservable();
        this.DisplayName = ko.validatedObservable();
        this.CurrentUserID = ko.validatedObservable();
        this.ContextID = ko.validatedObservable();

        // Functions
        this.SendMessage = function () {

            var data = this.ExtractATO();
            var url = _baseApiUri + sm.portal.utility.formatString('api/student360/SendContextMessage/?toAddress={0}&fromAddress={1}&subject={2}&body={3}&currentUserID={4}&contextID={5}',
                data.toAddress,
                data.fromAddress,
                data.subject,
                data.body,
                data.currentUserID,
                data.contextID);
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                //data: JSON.stringify(data),
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                success: function (data, textStatus, jqXHR) {

                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'saved') {
                        // unblock UI so that user can resume work.   
                        jQuery.unblockUI();

                    } else if (data.Status == 'validationerror') {

                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                        // TODO: Identify and highlight the associated fields (if possible)

                    } else if (data.Status == 'error') {

                        viewModel.HandleError(container.ValidationTitle, container.ValidationMessages);
                    }
                },
                error: function (jqXHR, exception) {
                    viewModel.HandleError(exception);
                }
            });

        };
        this.CancelMessage = function () {
            // Close the Lightbox
            jQuery('.smModal .smModalClose').click();
        };
        this.ExtractATO = function () {

            var messageObject = ko.mapping.toJS(this);
            var data = {
                subject: messageObject.Subject,
                fromAddress: messageObject.FromAddress,
                toAddress: messageObject.ToAddress,
                body: messageObject.Html,
                currentUserID: _currentPersonId,
                contextID: messageObject.ContextID
            };
            return data;
        };

        return self;
    };

    jQuery.extend(true, sm.portal.vm, {
        SendCommunicationViewModel: SendCommunicationViewModel,
    });

})(jQuery);